export function getClusterAtts(count: number) {
  let dimension: number;
  let baseFontSize: number;

  if (count < 100) {
    dimension = 50;
    baseFontSize = 16;
  } else if (count < 500) {
    dimension = 60;
    baseFontSize = 18;
  } else if (count < 5000) {
    dimension = 75;
    baseFontSize = 22;
  } else {
    dimension = 100;
    baseFontSize = 26;
  }

  const scaler = 30 / dimension;
  return {
    dimension,
    fontSize: baseFontSize * scaler,
    strokeWidth: 2 * scaler,
  };
}
